<template>
    <nav class="navbar primary navbar-expand-lg weeduc-admin-toolbar">
        <div class="toolbar-goback" @click="goBack">
            <fa icon="fa-arrow-left"/>
        </div>
        <div class="container">
            <div class="navbar-wrapper primary">
                <div class="wrapper-inner">
                    <div class="navbar-breadcrumb">
                        <ul class="breadcrumb">
                            <li v-for="(item, index) in items" :key="index"
                                :class="{ 'breadcrumb-item': true, 'active': item.active }">
                                <router-link v-if="!item.active" class="link-breadcrumb" :to="item.link">
                                    {{ item.label }}
                                </router-link>
                                <span v-else>{{ item.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="wrapper-inner">
                    <ul class="navbar-nav primary">
                        <li @click="changeSideBarState()" class="mobileClickMenu">
                            <a href="#">
                                <fa icon="fa-bars"/>
                            </a>
                        </li>
                        <li>
                            <a :href="websites.url" target="_blank" class="link-toolbar">
                                <svg class="icon-default" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>
                                <span class="link-text">Visualizar Site</span>
                            </a>
                        </li>
                        <li>
                            <a href="/aluno/dashboard" target="_blank" class="link-toolbar">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z"/></svg>
                                <span class="link-text">Portal do aluno</span>
                            </a>
                        </li>
                        <li class="nav-item icon-toolbar">
                            <a class="nav-icon" @click="toggleDarkModeFunction()"> 
                                <fa icon="sun" v-show="dark"/>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A1964" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" v-show="!dark">
                                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item dropdown user-avatar" @click="toggleDropdown">
                            <a class="nav-link dropdown-toggle">
                                <img class="image-user" :src="user && user.photoFinal ? user.photoFinal : '/img/user.e69f11a5.png'" />
                                <span v-if="user && user.firstName && user.lastName">
                                    {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
                                </span>
                            </a>
                            <ul class="dropdown-menu" :class="{ show: isDropdownOpen }" ref="dropdownMenu">
                                <li class="dropdown-item">
                                    <a class="link-dropdown" @click="gotoUserEdit">Editar Perfil</a>
                                </li>
                                <li class="dropdown-item">
                                    <a class="btn btn-block btn-dropdown" @click="logout">Sair</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>

    <EditUser
        v-if="openmodaledituser"
        :show="openmodaledituser"
        :id="user.id"
        @open-tab="atualizarValorNoFilhoEdit"
    />
</template>

<script>
import store from '@/store';
import { mapState, mapActions } from 'vuex';
import EditUser from '@/components/Admin/Users/Edituser/edituser.vue';

export default {
    props: {
        items: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            typeUser: 0,
            openmodaledituser: false,
            isDropdownOpen: false
        };
    },
    computed: {
        ...mapState(['dark', 'user', 'websites'])
    },
    components: {
        EditUser,
    },
    methods: {
        ...mapActions(['storeTypeId', 'storeDark', 'toggleDarkMode', 'storeSideBarState']),
        logout() {
            localStorage.removeItem('vuex');
            localStorage.removeItem('activeIndex');
            localStorage.removeItem('logado');
            window.location.href = "/login";
        },
        toggleDarkModeFunction() {
            this.toggleDarkMode({ dark: !this.dark });
            if (this.dark) {
                document.body.classList.add('dark');
                this.$vuetify.theme.global.name = 'dark';
            } else {
                document.body.classList.remove('dark');
                this.$vuetify.theme.global.name = 'light';
            }
        },
        goBack(){
            window.history.back();
        },
        atualizarValorNoFilhoEdit(novovalor) {
            this.openmodaledituser = novovalor;
        },
        changeSideBarState() {
            this.storeSideBarState({ sideBarState: !this.sideBarState });
        },
        gotoUserEdit() {
            this.$router.push('/dashboard/form-usuario/' + this.user.id);
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        }
    },
    created() {
        this.typeUser = store.state.typeId;
        
    },
    mounted() {
        // Aplica o dark mode na inicialização se estiver ativo
        if (this.dark) {
            document.body.classList.add('dark');
            this.$vuetify.theme.global.name = 'dark';
        } else {
            document.body.classList.remove('dark');
            this.$vuetify.theme.global.name = 'light';

        }
    },
};
</script>

<style scoped>
.toolbar-goback {
    display: flex;
    align-items: center;
    margin-right: 16px;
    cursor: pointer;
    position: absolute;
    left: 10px;
    top: 17px;
}
.toolbar-goback svg {
    color: #250991;
    font-size: 20px !important;
}
.container {
    box-shadow: none !important;
    max-width: 95%;
}
.navbar {
    --bs-navbar-padding-y: 0 !important;
}
.navbar.primary {
    background-color: #eef0fc;
    border-bottom: 1px solid #f6f6f6;
    width: 99%;
}
.navbar.primary>.container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    max-width: 100%;
}
.navbar>.container{
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between;
}
.navbar.primary .navbar-wrapper.primary {
    display: flex;
    align-items: center;
    width: 100% !important;
    justify-content: space-between;
    flex-direction: row;
    padding: 5px 0px 5px 0px;
}
.navbar.primary .navbar-wrapper.primary>.wrapper-inner {
    display: flex;
    align-items: center;
}
.navbar.primary {
    background-color: #fff;
    width: 100% !important;
}
.navbar.primary .navbar-nav.primary {
    display: flex;
    align-items: center;
    flex-direction: row !important;
    margin: 0;
    padding: 0;
}
.navbar.primary .navbar-nav.primary .nav-item:first-child {
    margin-right: 1rem !important;
}
.navbar.primary .navbar-breadcrumb .breadcrumb {
    padding: 0 !important;
    margin: 0 !important;
}
.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item {
    padding: 0 !important;
}
.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item:first-child .link-breadcrumb {
    padding-left: 0 !important;
}
.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    text-decoration: none;
    color: #9d9fa3;
}
.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb.active {
    color: #18181c;
}
.dark .navbar-nav.primary svg {
    color: white;
}
.navbar-nav.primary svg {
    color: #767676;
}
li.logout {
    margin: 0 10px;
}
.dashboard.dark .logout i {
    color: white;
}
.logout i {
    color: black;
}
.image-user{
    width: 25px;
}
li.nav-item {
    cursor: pointer !important;
}
li.nav-item.icon-toolbar i {
    color: black;
    font-size: 20px;
}
.dashboard.dark li.nav-item.icon-toolbar i {
    color: white;
    font-size: 20px;
}
ul.dropdown-menu.show {
    padding: 0;
}
ul.navbar-nav.primary li {
    margin: 0px 10px;
    cursor: pointer;
    position: relative;
}
.dark ul.navbar-nav.primary li a {
    color: #fff;
}
ul.navbar-nav.primary li a {
    text-decoration: none;
    color: black;
    position: relative;
}
ul.navbar-nav.primary li a.link::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #bebebe;
    top: 110%;
    left: 0;
    opacity: 0;
    transition: all 500ms linear;
}
ul.navbar-nav.primary li a.link:hover::after {
    opacity: 1;
}
@media (min-width: 600px) {
    .mobileClickMenu {
        display: none;
    }
}
@media (max-width: 600px) {
    .weeduc-admin-toolbar .navbar-nav.primary {
        display: flex;
        flex-direction: row !important;
        align-items: center;
        gap: 5px;
    }

    .weeduc-admin-toolbar .navbar-nav.primary li a .link-text {
        display: none;
    }
    
    .weeduc-admin-toolbar .navbar-nav.primary li {
        margin: 0 5px;
    }
    
    .weeduc-admin-toolbar .container {
        max-width: 100%;
        padding: 0 10px;
    }
    
    .weeduc-admin-toolbar .navbar-wrapper.primary {
        gap: 10px;
    }
}
ul.navbar-nav.primary li a {
    color: #1A1964;
}
.navbar-nav.primary .link-toolbar:hover {
    color: #260791;
}
.navbar-nav.primary .link-toolbar:hover svg {
    fill: #260791;
}
.navbar-nav.primary svg:hover {
    stroke: #260791;
    fill: #260791;
}
.navbar-nav.primary svg {
    color: #1A1964;
    vertical-align: sub;
}
.navbar-nav.primary .link-toolbar svg,
.navbar-nav.primary .link-toolbar span {
    fill: #1A1964;
    height: 20px;
}
.mobileClickMenu a svg {
    height: 20px;
}
svg.svg-inline--fa {
    font-size: 16px !important;
}
/* DARK MODE */
.dark ul.navbar-nav.primary li a {
    color: #EBEBF5;
}
.dark .navbar-nav.primary svg {
    color: #EBEBF5;
    stroke: #EBEBF5;
}
.dark .navbar-nav.primary .link-toolbar svg {
    fill: #EBEBF5;
}
.dark .container {
    background-color: transparent !important;
}
.dark .toolbar-goback svg {
    color: #EBEBF5;
}

.dark .navbar-nav.primary .link-toolbar {
    color: #FFFFFF;
}
/* DROPDOWN */
.dropdown-menu {
    position: absolute;
    top: 100% !important;
    right: 0 !important;
}
.dropdown-item {
    width: auto;
    margin: 0;
    padding: 10px 10px;
}
.btn:last-child {
    width: 100%;
    text-align: center;
    background-color: #1A1964;
    color: #fff !important;
}
.btn:last-child:hover {
    background-color: #260791;
    color: #fff !important;
}
ul.navbar-nav.primary .dropdown-item a:hover {
    color: #260791;
    background-color: none !important;
}
.dropdown-item:focus {
    background-color: none !important;
}
.dropdown-item:hover {
    background-color: transparent !important;
}
/* MOBILE MEDIA */
@media (max-width: 600px) {
    .navbar-nav .dropdown-menu {
        position: absolute !important;
    }
}
</style>